import React, { useContext, useEffect, useState } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import {
  checkAndStoreCookieValueForVirtualizationConsole,
  epocToDate,
  openWithPost,
  decryptData,
  redirectToRPCVirtualizationConsole
} from "utils";

import Tooltip from "App/common/ui/Tooltip";
import Loader from "App/common/ui/Loader";
import { LayoutContext } from "App/common/hoc/Layout";
import { formatBytes, decodeHandler } from "utils";
import {
  VM_STATUS_ENUM,
  VM_NETWORK_SOURCE,
  VM_STORAGE_TARGET_BUS,
  VIRTUALIZATION_WARNING_MSG,
  TOOLTIPS,
  STATIC_URLS,
  VM_CONTROL_ACTIONS,
  CONTENT
} from "consts";
import {
  controlVMStart,
  fetchVMsListStart,
  deleteVMStart,
  rebuildVMStart
} from "store/actions";
import { ReactComponent as VirtualizationAlert } from "assets/images/app_svg/virtualization_alert.svg";

function Machine(props) {
  const { lMethods } = useContext(LayoutContext);
  const [showWarningMsg, setShowWarningMsg] = useState(true);
  const [vmRpcStatus, setVmRpcStatus] = useState(
    props.rpcMachineStatusVi?.find(item => item.machine_id === props.rpc_mac_id)
  );

  useEffect(() => {
    setVmRpcStatus(
      props.rpcMachineStatusVi?.find(
        item => item.machine_id === props.rpc_mac_id
      )
    );
  }, [props.rpcMachineStatusVi, props.rpc_mac_id]);

  //sending host data to rpc iframe on READY_FOR_DATA message every 2 seconds
  useEffect(() => {
    const handleMessage = event => {
      const msg = event.data;
      const vmRpcStatus = props.rpcMachineStatusVi?.find(
        item => item.machine_id === msg.machineId
      );
      if (
        event.origin !== STATIC_URLS.rpcVirtualisationDomain.idrive ||
        !vmRpcStatus
      ) {
        return;
      }

      if (msg.type === "READY_FOR_DATA") {
        const vm = props.vmsList.find(
          item => item.rpc_mac_id === msg.machineId
        );
        if (vm) {
          const machineDetails = {
            type: "HOST_DATA",
            machine_id: vm.machine_id,
            host_name: vm.hostname,
            viewer_id: decryptData(localStorage.getItem("viewerId")),
            host_os: vm.host_os,
            flag: "1",
            webAccessToken: props.rpcSocketDetailsVi.token
          };
          event.source.postMessage(
            machineDetails,
            STATIC_URLS.rpcVirtualisationDomain.idrive
          );
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [props.rpcMachineStatusVi, props.rpcSocketDetailsVi?.token]);

  //connect to rpc web viewer if rpc socket details are present otherwise use novnc link
  const handleConnectButton = () => {
    if (
      props.boot_params.enable === "no" &&
      props.network?.source !== "disconnected" &&
      vmRpcStatus?.machine_id.includes("_") &&
      (vmRpcStatus?.host_status === "1" || vmRpcStatus?.host_status === "2")
    ) {
      redirectToRPCVirtualizationConsole(vmRpcStatus.machine_id);
    } else {
      connectViaNoVnc();
    }
  };

  const connectViaNoVnc = () => {
    const isSessionPresent = checkAndStoreCookieValueForVirtualizationConsole(
      props.vm_uuid
    );
    if (isSessionPresent) {
      lMethods.openPopup("virtualizationConsoleSessionExists", {
        execute: () => {
          lMethods.closePopup();
        }
      });
    } else {
      const url = props.connection_url.split("?token=")[0];
      const token = props.connection_url.split("?token=")[1];
      const source = process.env.REACT_APP_NAME;
      openWithPost(url, { token: token, source: source }, true);
    }
    setTimeout(() => {
      props.fetchVMsListStart(false);
    }, 1000);
  };

  const handlePower = ({
    status,
    vm_uuid,
    controlVMStart,
    hostname,
    client_uuid
  }) => {
    const action = status === 1 ? "power_off" : "power_on";

    if (status === 1) {
      lMethods.openPopup("SwitchPowerVirtualInstance", {
        execute: () => {
          controlVMStart({ vm_uuid, action, hostname, client_uuid });
          lMethods.closePopup();
        }
      });
    } else {
      controlVMStart({ vm_uuid, action, hostname, client_uuid });
    }
  };

  const handleDelete = () => {
    if (props.status !== 1) {
      lMethods.openPopup("DeleteVirtualInstance", {
        execute: () => {
          props.deleteVMStart({
            vm_uuid: props.vm_uuid,
            hostname: props.hostname
          });
          lMethods.closePopup();
        }
      });
    }
  };

  const handleReboot = props => {
    if (props.status === 1) {
      lMethods.openPopup("RebootVirtualInstance", {
        execute: () => {
          props.controlVMStart({
            vm_uuid: props.vm_uuid,
            action: "reboot",
            hostname: props.hostname,
            client_uuid: props.client_uuid
          });
          lMethods.closePopup();
        }
      });
    }
  };

  function checkForWarningFlag(date) {
    const diffDays = moment().diff(moment(date), "days");
    if (diffDays > VIRTUALIZATION_WARNING_MSG.deleteMsg.threshold) {
      const days = VIRTUALIZATION_WARNING_MSG.deleteMsg.finalDays - diffDays;
      return (
        <div className="virtual_success_msg">
          <span class="icon">
            <VirtualizationAlert />
            <span className="vsm_span">
              {VIRTUALIZATION_WARNING_MSG.deleteMsg.msg +
                " " +
                (days === 1
                  ? "tomorrow"
                  : days < 1
                  ? "today"
                  : " in " + days + " days")}
              <a
                target="_blank"
                href={
                  STATIC_URLS.virtualisationFaq[
                    props?.origin === "idrive" ? "idrive" : "mirror"
                  ]
                }
              >
                {" "}
                Know more.
              </a>
            </span>
          </span>
          <span
            className="vm_message_close"
            onClick={() => setShowWarningMsg(false)}
          ></span>
        </div>
      );
    } else if (diffDays > VIRTUALIZATION_WARNING_MSG.shutdownMsg.threshold) {
      const days = VIRTUALIZATION_WARNING_MSG.shutdownMsg.finalDays - diffDays;
      return (
        <div className="virtual_success_msg">
          <span class="icon">
            <VirtualizationAlert />
            <span className="vsm_span">
              {VIRTUALIZATION_WARNING_MSG.shutdownMsg.msg.part1 +
                " " +
                (days === 1
                  ? "tomorrow"
                  : days < 1
                  ? "today"
                  : " in " + days + " days") +
                VIRTUALIZATION_WARNING_MSG.shutdownMsg.msg.part2}
              <a
                target="_blank"
                href="https://www.idrivemirror.com/faq_virtualization#virtualizing-machine"
              >
                {" "}
                Know more.
              </a>
            </span>
          </span>
          <span
            className="vm_message_close"
            onClick={() => setShowWarningMsg(false)}
          ></span>
        </div>
      );
    }
  }

  function displayRecoveryPointDate() {
    let result = "";
    result = moment
      .utc(props.rec_point)
      .local()
      .format("MMM DD YYYY, hh:mm:ss");
    if (result === "Invalid date") {
      result = epocToDate(props.rec_point, "MMM d yyyy, HH:mm:ss");
    }
    return result;
  }

  return (
    <React.Fragment>
      {showWarningMsg && checkForWarningFlag(props.created_date)}
      <div
        className={[
          "virtual_inner_li",
          props.loading || props.status === 9
            ? "virtual_disabled virtual_layer"
            : props.status === 5
            ? "virtual_off virtual_layer"
            : props.status === 1
            ? "virtual_on virtual_layer"
            : "new"
        ].join(" ")}
      >
        <div className="virtual_lhs">
          <div className="top_header">
            <div className="machine_name">
              <span className="icon_machine">
                <i></i>
              </span>
              <span className="mac_tile">{decodeHandler(props.hostname)}</span>
            </div>
            <div className="machine_status">
              <span className="grey_txt">Status: </span>
              <span className="highlights_txt">
                {" "}
                {VM_STATUS_ENUM[props.status]}
              </span>
            </div>
          </div>
          <div className="machine_info">
            <div className="machine_info_lhs">
              <div className="img_wrapper">
                <div className="img_machine"></div>
                {/* <div className="machine_os grey_txt">{props.os_type ? props.os_type : "Windows 10"}</div> */}
              </div>
            </div>
            <div className="machine_info_rhs">
              <div className="computer_info">
                <div className="machine_specs">
                  <div className="spec_li">
                    <div>
                      <span className="icon processor"></span>
                      <span className="info_text grey_txt">
                        Processor(s)
                      </span>{" "}
                    </div>
                    <div className="highlights_txt"> {props.processors} </div>
                  </div>
                  <div className="spec_li">
                    <div>
                      <span className="icon memory"></span>
                      <span className="info_text grey_txt">Memory</span>{" "}
                    </div>
                    <div className="highlights_txt">
                      {" "}
                      {formatBytes(props.memory)}{" "}
                    </div>
                  </div>
                  <div className="spec_li">
                    <div>
                      <span className="icon controller"></span>
                      <span className="info_text grey_txt">
                        Controller
                      </span>{" "}
                    </div>
                    <div className="highlights_txt">
                      {VM_STORAGE_TARGET_BUS[props.storage_params.target_bus]}
                    </div>
                  </div>
                  <div className="spec_li">
                    <div>
                      <span className="icon network"></span>
                      <span className="info_text grey_txt">Network</span>{" "}
                    </div>
                    <div className="highlights_txt">
                      {" "}
                      {props.network
                        ? VM_NETWORK_SOURCE[props.network.source]
                        : VM_NETWORK_SOURCE["none"]}{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="virtual_rhs">
          <div className="table_wrapper">
            <div className="table_body_top just_flex">
              <div className="table_data">
                <div
                  className="v_icon_item v_connect"
                  onClick={() => props.status === 1 && handleConnectButton()}
                >
                  <Tooltip
                    title={
                      props.status === 1 &&
                      (props.boot_params.enable === "no" ||
                        props.network?.source !== "disconnected") &&
                      vmRpcStatus?.host_status !== "1" &&
                      vmRpcStatus?.host_status !== "2" &&
                      vmRpcStatus?.machine_id.includes("_")
                        ? "Virtual instance configuration is in progress. You can access it via Classic mode."
                        : ""
                    }
                    placement="top"
                  >
                    <div
                      className={[
                        "common_btn btn_primary",
                        props.status === 1 ? "" : "btn_disable"
                      ].join(" ")}
                    >
                      CONNECT
                    </div>
                  </Tooltip>
                </div>
              </div>
              <div className="table_data " onClick={() => handlePower(props)}>
                <div className="v_icon_item v_power v_shutdown">
                  <div className="v_icon"></div>
                  <div className="v_name v_name nowrap">
                    {props.status === 1 ? "Power Off" : "Power On"}
                  </div>
                </div>
              </div>
              <div
                className="table_data"
                onClick={() => props.status === 1 && handleReboot(props)}
              >
                <div
                  className={[
                    "v_icon_item v_reboot",
                    props.status !== 1 ? "v_disable" : ""
                  ].join(" ")}
                >
                  <div className="v_icon"></div>
                  <div className="v_name">Reboot</div>
                </div>
              </div>
              {props.status === 1 ? (
                <Tooltip
                  title={"Power off the virtual instance to delete."}
                  placement="top"
                >
                  <div
                    className="table_data "
                    onClick={() => handleDelete(props)}
                  >
                    <div
                      className={[
                        "v_icon_item v_delete",
                        props.status === 1 ? "v_disable" : ""
                      ].join(" ")}
                    >
                      <div className="v_icon"></div>
                      <div className="v_name">Delete</div>
                    </div>
                  </div>
                </Tooltip>
              ) : (
                <div
                  className="table_data "
                  onClick={() => handleDelete(props)}
                >
                  <div
                    className={[
                      "v_icon_item v_delete",
                      props.status === 1 ? "v_disable" : ""
                    ].join(" ")}
                  >
                    <div className="v_icon"></div>
                    <div className="v_name">Delete</div>
                  </div>
                </div>
              )}
              {props.status === 1 ? (
                <Tooltip
                  title={"Power off the virtual instance to reconfigure."}
                  placement="top"
                >
                  <div
                    className="table_data network"
                    onClick={() => {
                      if (props.status !== 1) {
                        lMethods.openSlidingPopup(
                          "virtualMachine",
                          "editConfiguration",
                          { ...props }
                        );
                      }
                    }}
                  >
                    <div
                      className={[
                        "v_icon_item v_configure v_configure_btn",
                        props.status === 1 ? "v_disable" : ""
                      ].join(" ")}
                    >
                      <div className="v_icon"></div>
                      <div className="v_name nowrap">Reconfigure</div>
                    </div>
                  </div>
                </Tooltip>
              ) : (
                <div
                  className="table_data network"
                  onClick={() => {
                    if (props.status !== 1) {
                      lMethods.openSlidingPopup(
                        "virtualMachine",
                        "editConfiguration",
                        { ...props }
                      );
                    }
                  }}
                >
                  <div
                    className={[
                      "v_icon_item v_configure v_configure_btn",
                      props.status === 1 ? "v_disable" : ""
                    ].join(" ")}
                  >
                    <div className="v_icon"></div>
                    <div className="v_name nowrap">Reconfigure</div>
                  </div>
                </div>
              )}
            </div>
            <div className="table_body_bottom just_flex">
              <div className="v_data_item operating_system">
                <p className="title">Operating System:</p>
                <p>{props.os_type}</p>
              </div>
              <div className="v_data_item recovery_point">
                <p className="title">Recovery Point:</p>
                <p>{displayRecoveryPointDate()}</p>
              </div>
              <div className="v_data_item created_on">
                <p className="title">Created On:</p>
                <p>
                  {moment(props.created_date).format("MMM DD YYYY, HH:mm:ss")}
                </p>
              </div>
            </div>
          </div>
        </div>
        {props.status === 9 && (
          <div className="disabled_layer flex_center">
            <Tooltip {...TOOLTIPS.virtualization.rebuild}>
              <div
                className="create_vm_btn"
                onClick={() =>
                  props.rebuildVMStart(props.vm_uuid, props.hostname)
                }
              >
                Rebuild Virtual Instance
              </div>
            </Tooltip>
          </div>
        )}
        {Object.keys(props.rpcConsoleAccessinProgressList).includes(
          props.client_uuid
        ) && (
          <div className="disabled_layer flex_center">
            <p className="vi_loading_message">
              Building virtual machine for{" "}
              <strong>{decodeHandler(props.hostname)}</strong>. It may take some
              time.
            </p>
          </div>
        )}
        {(props.loading ||
          Object.keys(props.rpcConsoleBootProgressList).includes(
            props.client_uuid
          )) && (
          <div className="disabled_layer flex_center">
            <p className="vi_loading_message">
              {props.rpcConsoleBootProgressList[props.client_uuid]
                ?.isBuilding ? (
                <>
                  Building virtual machine for{" "}
                  <strong>{decodeHandler(props.hostname)}</strong>. It may take
                  some time.
                </>
              ) : (
                <>
                  {
                    CONTENT.virtualization.loaderMessages[
                      props.status === VM_CONTROL_ACTIONS["power_off"]
                        ? "powerOffVm"
                        : props.status === VM_CONTROL_ACTIONS["delete"]
                        ? "deleteVm"
                        : "powerOnVm"
                    ]
                  }
                  <strong>{decodeHandler(props.hostname)}</strong>...
                </>
              )}
            </p>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      fetchVMsListStart,
      controlVMStart,
      deleteVMStart,
      rebuildVMStart
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    origin: state.account.origin,
    vmsList: state.virtualization.vmsList,
    rpcMachineStatusVi: state.virtualization.rpcMachineStatusVi,
    rpcSocketDetailsVi: state.virtualization.rpcSocketDetailsVi,
    rpcConsoleAccessinProgressList:
      state.virtualization.rpcConsoleAccessinProgressList,
    rpcConsoleBootProgressList: state.virtualization.rpcConsoleBootProgressList,
    email: state.account.userDetails.emailid
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Machine);
